import { render } from "./RegistroPorFechas.vue?vue&type=template&id=37c8a2d2&scoped=true"
import script from "./RegistroPorFechas.vue?vue&type=script&lang=js"
export * from "./RegistroPorFechas.vue?vue&type=script&lang=js"

import "./RegistroPorFechas.vue?vue&type=style&index=0&id=37c8a2d2&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c8a2d2"]])

export default __exports__